import React from 'react';
import './LatestRequest.css';  
import { FiMapPin } from "react-icons/fi";  

const LatestRequest = ({ data, onCardClick }) => {
    return (
        <div className="latest-request-container">
            {data.map((item, index) => (
                <div key={index} className="card" onClick={() => onCardClick(item)}> {/* Pass the ID */}
                    <div className="card-header">
                        <h3 className="card-title">{item.title}</h3>
                        <button className="request-button">Request</button>
                    </div>
                    <div className="location-row">   
                        <FiMapPin className="location-icon" size={18} />
                        <span className="location-text">{item.District}</span>
                    </div>
                    <p className="card-description">{item.Description}</p>
                    <p className="card-amount">{item.Price}/M</p>
                </div>
            ))}
        </div>
    );
};

export default LatestRequest;
